import { MenuDto, UserDto, UserExtDto, UserLoginDto } from '@/models/dtos'
import { BreadcrumbRoute } from '@/models/types'
import { defineStore } from 'pinia'
import { RouteRecordRaw } from 'vue-router'
import storage from '@/utils/storage'
import { normalRoutes, roleRoutes } from '@/configs/route.config'
import { clone, dataToPromiseTree, filterAsyncRouter } from '@/utils'
import {MenuClass, AccountClass} from '@/apis/ucenter'
import { LoginArgs } from '@/models/args'
import { readonly, shallowRef, toRaw } from 'vue'

const accountApi = new AccountClass()
const menuApi = new MenuClass()

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      token: '',
      userInfo: null as UserDto | null,
      userExtInfo: null as UserExtDto | null,
      menus: <Array<MenuDto>>[],
      routers: <Array<RouteRecordRaw>>[],
      roleRouters: <Array<RouteRecordRaw>>[],
      breadcrumbRoutes: <Array<BreadcrumbRoute>>[]
    }
  },
  getters: {},
  actions: {
    setUserInfo(user: UserDto){
      this.$patch({
        userInfo: user
      })
    },

    setToken(token: string){
      if(token){
        this.token = token
        storage.set('BEARER_TOKEN', token)
      }
    },

    onLogout(){
      return new Promise((resolve) => {
        storage.remove('BEARER_TOKEN')
        storage.remove('IOT_TOKEN')
        resolve(1)
      })
    },

    onLogin(args: LoginArgs){
      return new Promise((resolve, reject) => {
        accountApi.login(args).then((resp) => {

          this.setToken(resp.token)
          
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    scanLogin(key:string){
      return new Promise<UserLoginDto>((resolve, reject) => {
        accountApi.scanLogin(key).then((resp) => {

          this.setToken(resp.token)
          
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getCode(){
      return new Promise<string>((resolve, reject) => {
        accountApi.getCode().then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    getCodeState(key:string){
      return new Promise<number>((resolve, reject) => {
        accountApi.getCodeState(key).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    onGetUserInfo(){
      return new Promise((resolve, reject) => {
        accountApi.info().then((resp) => {
          this.setUserInfo(resp)
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    onGetMenus(){
      return new Promise<MenuDto[]>((resolve, reject) => {
        menuApi.menus().then((res) => {
          if(res.length === 0){
            res = [
              {
                id: -1,
                name: '首页',
                sign: 'index',
                roleId: 0,
                type: 0,
                parentId: 0,
                sort: 0,
                remark: 'string',
                actions: []
              }
            ]
          }

          this.menus = res
          const pros = dataToPromiseTree(res, 0)
          resolve(pros)
        }).catch(e => {
          reject(e)
        })
      })
    },

    GenerateRoutes(permissionMenus: MenuDto[]){
      return new Promise((resolve) => {
        const menus = permissionMenus
        const accessedRouters = filterAsyncRouter(roleRoutes, menus)
        this.roleRouters = accessedRouters
        this.routers = normalRoutes.concat(accessedRouters)
        resolve(accessedRouters)
      })
    }
  }
})